import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Categories from "./pages/Categories";
import ContactPage from "./pages/Contact/ContactPage";
import CategoryDetailsPage from "./pages/CategoryDetailsPage/CategoryDetailsPage";
import AdminItemPage from "./pages/AdminItemPage/AdminItemPage";
import CatalogItemPage from "./pages/CatalogItemPage/CatalogItemPage";
import CatalogCategoryPage from "./pages/CatalogCategoryPage/CatalogCategoryPage";
import CartPage from "./pages/CartPage/CartPage";
import BlogPage from "./pages/BlogPage/BlogPage";
import BlogPostPage from "./pages/BlogPostPage/BlogPostPage";
import AdminBlogPage from "./pages/AdminBlogPage/AdminBlogPage";
import AdminBlogPostPage from "./pages/AdminBlogPostPage/AdminBlogPostPage";

function App() {
  const { user } = useAuthContext();

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <div className="pages">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route
              path="/categories"
              element={user ? <Categories /> : <Navigate to="/" />}
            />
            <Route
              path="/categories/:id"
              element={user ? <CategoryDetailsPage /> : <Navigate to="/" />}
            />
            <Route
              path="/categories/:id/items/:itemId"
              element={user ? <AdminItemPage /> : <Navigate to="/" />}
            />
            <Route
              path="/admin"
              element={!user ? <Login /> : <Navigate to="/" />}
            />
            <Route
              path="/admin/blog"
              element={user ? <AdminBlogPage /> : <Navigate to="/" />}
            />
            <Route
              path="/admin/blog/:id"
              element={user ? <AdminBlogPostPage /> : <Navigate to="/" />}
            />
            <Route path="/catalog/item/:id" element={<CatalogItemPage />} />
            <Route path="/catalog/:id" element={<CatalogCategoryPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogPostPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
